import React from "react";

export default function SocialMediaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M22.5 21.082s1.5 0 1.5-1.5-1.5-6-7.5-6-7.5 4.5-7.5 6 1.5 1.5 1.5 1.5h12Zm-11.966-1.5a.39.39 0 0 1-.022-.003l-.012-.002c.002-.396.25-1.545 1.139-2.581.831-.97 2.285-1.914 4.861-1.914 2.576 0 4.03.944 4.861 1.914.889 1.036 1.137 2.185 1.139 2.58l-.012.003a.39.39 0 0 1-.021.003H10.534ZM16.5 10.582a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm4.5-3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM10.404 14.002a8.817 8.817 0 0 0-1.845-.37c-.336-.033-.689-.05-1.059-.05-6 0-7.5 4.5-7.5 6 0 1 .5 1.5 1.5 1.5h6.325c-.212-.426-.325-.931-.325-1.5 0-1.515.566-3.063 1.635-4.356.365-.441.789-.853 1.269-1.224Zm-3.024 1.08c-.896 1.37-1.38 2.932-1.38 4.5H1.5c0-.391.246-1.545 1.139-2.586.818-.955 2.24-1.884 4.741-1.913ZM2.25 8.332a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      />
    </svg>
  );
}
